'use strict'

const $ = window.jQuery;

export default function () {
    $('[data-popin]').on('click', function () {
        $(`#${$(this).data('popin')}`).addClass('is-active');
    });

    $('.popin__close').on('click', function () {
        $('.popin').removeClass('is-active');
    });
};
